import { faExclamationTriangle, faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import QueryParams from '../../services/QueryParams';

const SSOError = () => {
    const queryParams = new QueryParams();
    return (
        <div className="text-center m-5 p-5">
            <div className="mb-5 text-danger">
                <FontAwesomeIcon className="fa-4x" icon={faExclamationTriangle} />
            </div>
            <h4>{queryParams.get("message") || "Something went wrong."}</h4>
            <div className="mt-5">
                <strong>
                    <Link to="/">
                        <FontAwesomeIcon className="mr-2" icon={faHome} />
                        insurEco Home
                    </Link>
                </strong>
            </div>
        </div>
    );
}

export default SSOError;